import { ProviderLink as DesignSystemProviderLink, Skeleton } from '@all-manager/design-system-v2';
import type { MouseEvent } from 'react';

import { useRouterLinkClick } from '../../../../hooks/useRouterLinkClick';
import { useSpacePath } from '../../../../hooks/useSpacePath';
import useGetProviderById from '../../api/useGetProviderById';

type Props = {
  providerId: string;
  variant?: 'body1' | 'body1Emphasis' | 'body2' | 'body2Emphasis' | 'caption';
  hideIcon?: boolean;
  onClick?: (event: MouseEvent<HTMLElement>) => void;
};

export default function ProviderLink(props: Props) {
  const spacePath = useSpacePath();
  const targetUrl = spacePath(`/providers/${props.providerId}`);
  const handleClick = useRouterLinkClick(targetUrl, props.onClick);
  const { data, isLoading } = useGetProviderById(props.providerId);

  if (isLoading) {
    return <Skeleton width={120} height={props.variant?.startsWith('caption') ? 16 : 20} />;
  }

  if (!data) {
    return null;
  }

  return (
    <DesignSystemProviderLink
      name={data.name}
      href={targetUrl}
      onClick={handleClick}
      variant={props.variant ?? 'body2'}
      hideIcon={props.hideIcon}
    />
  );
}
